<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedTeamId: null,
      selectedInboxId: null,
      whatsappTemplateMessage: null,
      showWhatsAppTemplatesModal: false,
    };
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
      teams: 'teams/getTeams',
    }),
    whatsappInboxes() {
      return this.inboxes.filter(
        inbox => inbox.channel_type === 'Channel::Whatsapp'
      );
    },
  },
  mounted() {
    this.$store.dispatch('teams/get');
    this.selectedInboxId = this.modelValue[0]?.selected_inbox_id;
    this.selectedTeamId = this.modelValue[0]?.selected_team_id;
    this.updateValue();
  },
  methods: {
    updateSelectedTeam(event) {
      const newSelectedTeamId = Number(event.target.value);
      this.selectedTeamId = newSelectedTeamId;
      this.updateValue();
    },
    updateSelectedInboxId(event) {
      const newSelectedInboxId = Number(event.target.value);
      this.selectedInboxId = newSelectedInboxId;
      this.updateValue();
    },
    updateValue() {
      this.$emit('update:modelValue', {
        selected_inbox_id: this.selectedInboxId,
        selected_team_id: this.selectedTeamId,
      });
    },
  },
};
</script>

<template>
  <div>
    <p>Caixa de entrada</p>
    <select
      v-model="selectedInboxId"
      class="max-w-full mb-0 mt-1 mr-1"
      :allow-empty="false"
      @change="updateSelectedInboxId"
    >
      <option
        v-for="inbox in whatsappInboxes"
        :key="inbox.id"
        :value="inbox.id"
      >
        {{ inbox.name }}
      </option>
    </select>
    <p>Time</p>
    <select
      v-model="selectedTeamId"
      class="max-w-full mb-0 mt-1 mr-1"
      :allow-empty="false"
      @change="updateSelectedTeam"
    >
      <option v-for="team in teams" :key="team.id" :value="team.id">
        {{ team.name }}
      </option>
    </select>
  </div>
</template>
